import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    bankTeam:
      '**Bank and advanced accounting**\n{count} check collections, exclusive insurance, accounting access...',
    basicBilling:
      'Invoicing tool: unlimited creation of quotes and invoices, customer catalog, customizable mentions, automatic reminders',
    basicFeatures:
      'Basic features: Invoicing tool, optional virtual cards, easy addition of receipts',
    basicIntro: 'Pro account for your banking operations',
    basicSupport: 'Advisors available 7 days a week',
    businessIntro: 'Pro account ideal for **growing teams**',
    cashDeposit: '**Cash Deposit**\n{count} per month',
    isComing: 'Coming soon',
    multipleAccounts: {
      titlePlural: `1 account + {secondaryBankAccountsCount} wallets`,
      titleSingular: `1 account + {secondaryBankAccountsCount} wallet`,
    },
    new: 'New',
    oldBasicSupport: 'Support 7 days a week',
    oldBusinessCards: '{count} {type} and {virtualCount} virtual cards',
    oldBusinessIntro: '**All of Shine Premium**',
    paymentCard: '{count} {type}',
    plusBilling:
      '**Customized invoicing tool**\nLogo on quotes and invoices, product and service catalogs',
    plusFeatures:
      '**Advanced features**\n{count} virtual cards included, {checkCount} check deposits / month',
    plusIntro: '**All of Shine Basic**',
    plusSupport:
      '**Exclusive insurances**\nLegal assistance, broken mobile screen...',
    premiumExtraFeatures:
      '**Advanced features**\n{count} virtual cards included, exclusive insurance...',
    premiumFeatures: '**Simplified collections**\nInvoicing tool, checks',
    premiumSupport: '**Priority** support, 7 days a week',
    prioritySupport: '**Priority support and phone callback 7 days a week**',
    proAccountAccess: '**Dedicated access to your accountant**',
    proBusinessTeamMember:
      '**{memberCountAccess} members** et **{cardCount} cards** {type} included',
    proIntro: '**All Shine Plus**',
    proIntroTeam: 'Pro account ideal for **small teams**',
    proPlusBusinessTeamWork:
      '**Team expenses **\nRestricted access, physical and virtual budget cards for your team',
    sepaTransferMonthBasic: '{count} transactions and direct debits',
    sepaTransferMonthPlusSolo:
      '**{count}** transactions included and higher limits',
    sepaTransferMonthProSolo:
      '**{count}** transactions included and the highest limits',
    sepaTransferMonthTeam: '**{count}** transactions included',
    supplementaryInsurance:
      '**Additional insurances**\nReduced exemption, insurance for computer breakage and theft',
  },
  fr: {
    bankTeam:
      '**Banque et comptabilité avancées**\n{count} encaissements de chèques, assurances exclusives, accès comptable...',
    basicBilling:
      'Outil de facturation : création illimitée de devis et factures, catalogue de clients, mentions personnalisables, relances automatiques',
    basicFeatures:
      'Fonctionnalités de base : cartes virtuelles en option, ajout facile de reçus, exports et intégrations comptables',
    basicIntro: 'Compte pro pour vos opérations bancaires',
    basicSupport: 'Conseiller·es disponibles 7j/7',
    businessIntro: 'Compte pro idéal pour les **équipes en croissance**',
    cashDeposit: '**Dépôt d’espèces**\n{count} / mois sans frais',
    isComing: 'À venir',
    multipleAccounts: {
      titlePlural: `1 compte + {secondaryBankAccountsCount} sous-comptes`,
      titleSingular: `1 compte + {secondaryBankAccountsCount} sous-compte`,
    },
    new: 'Nouveau',
    oldBasicSupport: 'Support 7j/7',
    oldBusinessCards: '{count} {type} et {virtualCount} cartes virtuelles',
    oldBusinessIntro: '**Tout Shine Premium**',
    paymentCard: '{count} {type}',
    plusBilling:
      '**Outil de facturation personnalisé**\nLogo sur devis et factures, catalogue de produits et services',
    plusFeatures:
      '**Fonctionnalités supplémentaires**\n{count} cartes virtuelles incluses,\n {checkCount} dépôts de chèques / mois',
    plusIntro: '**Tout Shine Basic**',
    plusSupport:
      '**Assurances exclusives**\nAssistance juridique, casse écran mobile...',
    premiumExtraFeatures:
      '**Fonctionnalités avancées**\n{count} cartes virtuelles incluses, assurances exclusives...',
    premiumFeatures:
      '**Encaissements simplifiés**\nOutil de facturation, chèques...',
    premiumSupport: 'Support **prioritaire**, 7j/7',
    prioritySupport: '**Assistance prioritaire et rappel téléphonique, 7j/7**',
    proAccountAccess: '**Accès dédié pour votre comptable**',
    proBusinessTeamMember:
      '**{memberCountAccess} membres** et **{cardCount} cartes** {type} incluses',
    proIntro: '**Tout Shine Plus**',
    proIntroTeam: 'Compte pro idéal pour les **petites équipes**',
    proPlusBusinessTeamWork:
      '**Dépenses en équipe **\nAccès restreints, cartes physiques et virtuelles à budget pour votre équipe',
    sepaTransferMonthBasic: '{count} mouvements et prélèvements',
    sepaTransferMonthPlusSolo:
      '**{count}** mouvements inclus et plafonds plus élevés',
    sepaTransferMonthProSolo:
      '**{count}** mouvements inclus et plafonds les plus élevés',
    sepaTransferMonthTeam: '**{count}** mouvements inclus',
    supplementaryInsurance:
      '**Assurances supplémentaires**\nFranchise réduite, assurance casse et vol d’ordinateur',
  },
} as const);

export default locales;
